import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({

    login: builder.mutation({
      query: (credentials) => ({
          url: '/Login',
          method: 'POST',
          responseHandler: 'text',
           //body: { ...credentials }
          body : {
            staffId: credentials.user,
            pw: credentials.pwd,
            
          }
          //body:  JSON.stringify(credentials) 
      })
    }),

    loginGlobalAccount: builder.mutation({
      query: (credentials) => ({
          url: '/Login/login-global-account',
          method: 'POST',
          responseHandler: 'text',
           //body: { ...credentials }
          body : {
            staffId: credentials.user,
            pw: credentials.pwd,
            
          }
          //body:  JSON.stringify(credentials) 
      })
    }),

    logout: builder.mutation({
      query: () => ({
        url: '/Login/Logout',
        method: 'POST',
        responseHandler: 'text',
         //body: { ...credentials }
      })
    }),

    refreshToken: builder.mutation({
      query: () => ({
        url: '/Login/refresh-token',
        method: 'POST',
        responseHandler: 'text',
      })
      // query: (authorization) => ({
      //     url: '/Login/refresh-token',
      //     method: 'POST',
      //     responseHandler: 'text',
      //     headers: {
      //       'Authorization': authorization,
      //     }
      // })
    }),
  }),
});

export const {
  useLoginMutation,
  useLoginGlobalAccountMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
} = authApiSlice;
